// CursorContext.tsx
import React, { createContext, useContext, useState } from 'react';

type CursorState = 'default' | 'link' | 'other';

type CursorContextType = {
  state: CursorState;
  setState: (value: CursorState) => void;
};

const CursorContext = createContext<CursorContextType | null>(null);

export const CursorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, setState] = useState<CursorState>('default');

  return (
    <CursorContext.Provider value={{ state, setState }}>
      {children}
    </CursorContext.Provider>
  );
};

export const useCursor = () => {
  const ctx = useContext(CursorContext);
  if (!ctx) throw new Error('useCursor must be used inside CursorProvider');
  return ctx;
};
